import React from "react";
import { FormControl } from "react-bootstrap";
import ajax from "../../lib/ajax.js";
import context from "../../lib/context.js";
import ReactDOM from 'react-dom';

export default class Office extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            offices: []
        };

        this.loadOffices = this.loadOffices.bind(this);
        this.onChange = this.onChange.bind(this);
    }    

    componentDidMount() {
        this.loadOffices();
    }

    loadOffices() {
        let self = this;
        ajax.api().get("get-offices")
            .then(function (res) {
                self.setState({ offices: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onChange(event) {
        var description = '';
        var office = this.state.offices.filter(x => x.code == event.target.value);

        if (office.length > 0) {
            description = office[0].description;
        }

        if (this.props.onChange)
            this.props.onChange(event.target.value, description);
    }

    render() {
        var offices = [];
        var allText = 'All';
        var useCode = false;

        if (this.props.allText !== undefined)
            allText = this.props.allText;

        if (this.props.useCode !== undefined)
            useCode = this.props.useCode;

        offices.push(<option key="All" value="" selected="true">{allText}</option>);
        
        this.state.offices.map(function (item, i) {
            offices.push(<option key={item.code} value={item.code}>{useCode == true ? item.code : item.codeDescription}</option>)
        }, this);

        return (   
            <div className="ap-report-control-dropdown">       
                <FormControl
                    id={this.props.id + '-select'}
                    componentClass="select"
                    value={this.props.value}
                    onChange={this.onChange}
                    inputRef={el => this.inputEl = el}
                    className={this.props.className}
                    readOnly={this.props.readOnly}>
                    {offices}
                </FormControl>
            </div>
        );
    }
}